import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div``

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const CheckArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
`

export const Title = styled.div`
  display: flex;
  font-size: 18px;
  font-family: Circular-Std-Bold;
  margin-bottom: 10px;
`

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: CircularStd;
  color: ${colors.placeholder};
  margin-left: 5px;
`
